import styled from 'styled-components';
import { Button } from '../../../../shared/common/Button';
import GenericDropDown from '../../../../shared/common/GenericDropDown';
import { GrowingInput } from '../../../../shared/common/GrowingInput';
import { textColor, themeColor, THEME_PRIMARY, THEME_SILVER } from '../../../../styles/basics/colors';
import PrivacyButton from '../../PrivacyButton';
import TotalDropDown from '../../TotalDropDown';

export const StSelectionListHeader = styled.div`
    display: flex;
    align-items: center;
`;

export const StBackButton = styled.a`
    margin-right: 10px;
    font-size: 28px;
    line-height: 1;
`;

export const StSelectionListIcon = styled.i`
    font-size: 20px;
    margin-right: 5px;
    line-height: 1 !important;
`;

export const StNameInput = styled(GrowingInput)`
    border-radius: 0;
    box-shadow: none;
    font-size: 20px;
    min-width: 50px;
    padding: 0;
    overflow: ${props => (props.truncated ? 'hidden' : null)};
    text-overflow: ${props => (props.truncated ? 'ellipsis' : null)};
    ::-ms-clear {
        display: none;
    }
`;

export const StCheck = styled.i<{ readonly active?: boolean }>`
    display: ${props => (props.active ? null : 'none')};
    ${textColor(THEME_PRIMARY)};
    cursor: pointer;
    position: absolute;
    right: 0;
    font-size: inherit;
`;

export const StListName = styled.div`
    position: relative;
    margin-right: 13px;
    font-size: 20px;
    line-height: 1;
`;

export const StListNameForm = styled.div<{ readonly active?: boolean }>`
    padding-right: ${props => (props.active ? '30px' : null)};
    border-bottom: 1px solid ${props => (props.active ? themeColor(THEME_SILVER) : 'transparent')};
`;

export const StCommentsButton = styled.div`
    color: black;
    transition: none;
    margin: 0 5px 0 15px;
    cursor: pointer;
    line-height: 1;

    i {
        font-size: 20px;
    }
`;

export const StButtonWithSpace = styled(Button)`
    margin-left: 5px;
`;

export const StPrivacyButton = styled(PrivacyButton)`
    margin: 0 15px 0 15px;
`;

export const StMoreButton = styled(GenericDropDown)`
    font-size: 22px;
    line-height: 1;

    && a {
        padding: 0;
        font-size: inherit;
        line-height: inherit;
    }
`;

export const StTotalDropDown = styled(TotalDropDown)`
    font-size: 16px;
    line-height: 1;

    && a {
        padding: 0;
        font-size: inherit;
        line-height: inherit;
    }
`;
